import axios from "lib/axios";

const getMyProfile = async () => {
  const { data } = await axios.get("/me");
  return data;
};

const validateNationalId = async (nationalIdData) => {
  const { data } = await axios.post("/user/nationalId", nationalIdData);
  return data;
};

const updateProfile = async (profileData) => {
  const { data } = await axios.put("/me", profileData);
  return data;
};

const activateOnCard = async (activationCode) => {
  const { data } = await axios.post("/onCard/activate", { activationCode });
  return data;
};

const getPublicProfile = async (userId)=>{
  const {data} = await axios.get(`/public/user/${userId}`)
  return data;
}

const getUploadAvatarUrl = async () => {
  const { data } = await axios.get("/user/uploadAvatar");
  return data;
};

const uploadDone = async (fileId) => {
  const { data } = await axios.post("/user/uploadAvatar");
  return data;
};

const getUploadPublicProfile = async (fileId) => {
  const { data } = await axios.get("/user/uploadPublicProfile");
  return data;
};

export {updateProfile, getMyProfile, activateOnCard, getUploadAvatarUrl, uploadDone, getPublicProfile, getUploadPublicProfile, validateNationalId};
